const formulaSequencesKeys = {
    sequences: () => ['formula_sequences'],
    detail: (id: string) => [...formulaSequencesKeys.sequences(), id],
    sequencesCatalogCount: () => [
        ...formulaSequencesKeys.sequences(),
        'sequenceCount',
    ],
};

export default formulaSequencesKeys;
